import type {Interpolation} from '@emotion/react';
import type {Theme} from '@travel-frontend/themes';

import {css} from '@emotion/react';

export const styles: Record<string, Interpolation<Theme>> = {
  default: (theme) => css`
    bottom: 74px !important;

    ${theme.respondUpTo(
      'md',
      css`
        bottom: 94px !important;
      `
    )}
  `,
};
